import React from "react";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../../Utils/Utils";
import { useState, useEffect } from "react";
import {
  Upload,
  Button,
  Spin,
  Input,
  Table,
  Typography,
  message,
  Form,
  Popconfirm,
} from "antd";
import "../ExpenseManagement/ContingentExpense.css";
import {
  LoadingOutlined,
  PlusOutlined,
  ReloadOutlined,
  UploadOutlined,
  FilterOutlined,
  DeleteOutlined,
  FullscreenOutlined,
  SearchOutlined,
  DownloadOutlined,
  CheckOutlined,
  EditOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import axios from "axios";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import Cookies from "js-cookie";
import {
  AddNewCorporateExpense,
  DeleteCorporateEmployee,
  UpdateCorporateExpense,
} from "../../Repository/CorporateExpenseManageRepository";
const { Text } = Typography;
const CorporateExpense = () => {
  const [FileListStatus, setFileListStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [oldData, setOldData] = useState([]);
  const jwtToken = Cookies.get("jwt_token");
  const [AdjUploadFlag, setAdjUploadFlag] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [manualLoadingFileName, setManualLoadingFileName] = useState("");
  const [uploadSpinLoader, setUploadSpinLoader] = useState(false);
  const [NewRecordKey, setNewRecordKey] = useState(null);
  const [spin, setSpin] = useState(false);
  const [SearchGrid, setSearchGrid] = useState("");
  const [CurrentEditingKey, setCurrentEditingKey] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [form] = Form.useForm();
  const [isDownloadEnabled, setDownloadEnabled] = useState(false);
  const isEditing = (record) => record.exp_id === CurrentEditingKey;

  const handleSaveCorporate = async (record) => {
    if (form.isFieldsTouched()) {
    const UpdatedData = form.getFieldsValue();
    UpdatedData.exp_id = record.exp_id;
    const Response = await UpdateCorporateExpense(UpdatedData);

    Response.result.isSuccess === true
      ? SuccessMessage(Response.result.message)
      : InfoMessage("Update Failed");
    GetTableData();
    setCurrentEditingKey("");

    const newTotalAmount = calculateTotalAmount(data);
    setTotalAmount(newTotalAmount);
  } else {
    InfoMessage("No changes to Save");
    }
  };
  const handleAddNewCorporate = async (record) => {
    const NewRecord = form.getFieldsValue();
    const allFieldsBlank = Object.values(NewRecord).every(value =>
      value === null || value === undefined || value === ""
    );
  
    if (allFieldsBlank) {
      ErrorMessage("Cannot add a blank record. Fill in at least one field.");
      return;
    }
    NewRecord.exp_id = record.exp_id;
    const Response = await AddNewCorporateExpense(NewRecord);
    Response.isCompleted === true
      ? SuccessMessage("Record Added Successfully")
      : InfoMessage("Update Failed");
    GetTableData();
    setCurrentEditingKey("");

    const newTotalAmount = calculateTotalAmount(data);
    setTotalAmount(newTotalAmount);
  };
  const handleDeleteCorporate = async (DeletableObject) => {
    const Response = await DeleteCorporateEmployee(DeletableObject);
    Response.isSuccess === true
      ? SuccessMessage(Response.message)
      : ErrorMessage(Response.message);
    GetTableData();
    const newTotalAmount = calculateTotalAmount(data);
    setTotalAmount(newTotalAmount);
  };

  const AddNewRecord = async () => {
    console.log(CurrentEditingKey);
    if (CurrentEditingKey === "") {
      let NewRecordArray = {};
      for (let index in columns) {
        NewRecordArray[columns[index].dataIndex] = "";
      }

      NewRecordArray.exp_id = "0";
      setOldData([...data]);
      setData([NewRecordArray, ...data]);
      form.setFieldsValue({ ...NewRecordArray });
      setNewRecordKey("0");
      setCurrentEditingKey("0");

      const newTotalAmount = calculateTotalAmount(data);
      setTotalAmount(newTotalAmount);
    } else {
      InfoMessage("Please save/discard the record");
    }
  };
  //Filter Feature for Grid Layout
  const filterProps = () => ({
    filteredValue: [SearchGrid],
    onFilter: (value, record) => {
      return (
        String(record.worker_ID)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.client_ID)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.file_Name).toLowerCase().includes(value.toLowerCase())
      );
    },
  });
  const SearchEmployee = (value) => {
    console.log(value);
    setSearchGrid(value);
  };
  const columns = [
    {
      title: "Client ID",
      dataIndex: "client_ID",
      width: 120,
      fixed: "left",
      editable: true,
      ...filterProps(),
    },
    {
      title: "Worker ID",
      dataIndex: "worker_ID",
      width: 120,
      // fixed:"left",
      editable: true,
    },
    {
      title: "Org",
      dataIndex: "org",
      width: 120,
      editable: true,
    },
    {
      title: "Job Number",
      dataIndex: "job_Number",
      width: 120,
      editable: true,
    },
    {
      title: "Pay Component",
      dataIndex: "pay_Compon",
      width: 120,
      editable: true,
    },
    {
      title: "Rate",
      dataIndex: "rate",
      width: 120,
      editable: true,
    },
    {
      title: "Rate Number",
      dataIndex: "rate_Number",
      width: 120,
      editable: true,
    },
    {
      title: "Hours",
      dataIndex: "hours",
      width: 120,
      editable: true,
    },
    {
      title: "Units",
      dataIndex: "units",
      width: 120,
      editable: true,
    },
    {
      title: "Line Date",
      dataIndex: "line_Date",
      width: 120,
      editable: true,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 120,
      editable: true,
    },
    {
      title: "Check Seq Number",
      dataIndex: "check_Seq_Number",
      width: 180,
      editable: true,
    },
    {
      title: "Override State",
      dataIndex: "override_State",
      width: 140,
      editable: true,
    },
    {
      title: "Override Local",
      dataIndex: "override_Local",
      width: 140,
      editable: true,
    },
    {
      title: "Override Local Jurisdiction",
      dataIndex: "override_Local_Jurisdiction",
      width: 200,
      editable: true,
    },
    {
      title: "Labor Override",
      dataIndex: "labor_Override",
      width: 140,
      editable: true,
    },
    {
      title: "Check Template",
      dataIndex: "check_Template",
      width: 200,
      editable: true,
    },
    {
      title: "Output Type",
      dataIndex: "output_Type",
      width: 140,
      editable: true,
    },
    {
      title: "Net Pay",
      dataIndex: "netPay",
      width: 120,
      editable: true,
    },
    {
      title: "Check Number",
      dataIndex: "checkNumber",
      width: 120,
      editable: true,
    },
    {
      title: "FIT Amt",
      dataIndex: "fiT_Amt",
      width: 120,
      editable: true,
    },
    {
      title: "SS Amt",
      dataIndex: "sS_Amt",
      width: 120,
      editable: true,
    },
    {
      title: "Medicare Amt",
      dataIndex: "medicareAmt",
      width: 120,
      editable: true,
    },
    {
      title: "Fed Backup Withholding Amt",
      dataIndex: "fedBackup_WithholdingAmt",
      width: 220,
      editable: true,
    },
    {
      title: "State Tax Jurisdiction",
      dataIndex: "stateTax_Jurisdiction",
      width: 200,
      editable: true,
    },
    {
      title: "SIT Amount",
      dataIndex: "siT_Amount",
      width: 120,
      editable: true,
    },
    {
      title: "SDI Amt",
      dataIndex: "sdI_Amt",
      width: 120,
      editable: true,
    },
    {
      title: "SUI Amt",
      dataIndex: "suI_AmtStateMisc_Amt",
      width: 120,
      editable: true,
    },
    {
      title: "State Misc Amt",
      dataIndex: "state_Surcharge_Amt",
      width: 120,
      editable: true,
    },
    {
      title: "State Surcharge Amt",
      dataIndex: "expence_reim_cantingentcol",
      width: 160,
      editable: true,
    },
    {
      title: "State WC Amt",
      dataIndex: "stateWC_Amt",
      width: 120,
      editable: true,
    },
    {
      title: "State Backup Withholding Amt",
      dataIndex: "stateBackupWithholding_Amt",
      width: 220,
      editable: true,
    },
    {
      title: "State Allocation %",
      dataIndex: "state_Allocation",
      width: 140,
      editable: true,
    },
    {
      title: "Local Tax Jurisdiction",
      dataIndex: "localTax_Jurisdiction",
      width: 160,
      editable: true,
    },
    {
      title: "Local Tax Name",
      dataIndex: "local_TaxName",
      width: 120,
      editable: true,
    },
    {
      title: "Local Amt",
      dataIndex: "local_Amt",
      width: 120,
      editable: true,
    },
    {
      title: "Local Allocation %",
      dataIndex: "local_Allocation",
      width: 140,
      editable: true,
    },
    {
      title: "File No",
      dataIndex: "file_Name",
      width: 120,
      // fixed:"right",
      editable: true,
    },
    {
      title: "Paychex Code",
      dataIndex: "paychexCode",
      width: 120,
      // fixed: "right",
      editable: true,
    },
    {
      title: "GL Name",
      dataIndex: "gL_Name",
      width: 120,
      // fixed: "right",
      editable: true,
    },
    {
      title: "GL Account #",
      dataIndex: "gL_Account",
      width: 120,
      // fixed: "right",
      editable: true,
    },
    {
      title: "Processed Date",
      dataIndex: "processeddate",
      width: 120,
      // fixed: "right",
      editable: true,
    },
    {
      title: "Action",
      key: "edit",
      fixed: "right",
      width: 60,
      render: (_, record) => {
        return (
          <>
            {isEditing(record) ? (
              // When isEditing is true
              <div>
                {record.exp_id === NewRecordKey ? (
                  // When NewRecordKey is "tempId"
                  <PlusOutlined onClick={() => handleAddNewCorporate(record)} />
                ) : (
                  <CheckOutlined
                    onClick={() => handleSaveCorporate(record)}
                    style={{ marginRight: "5px", color: "green" }}
                  />
                )}

                <CloseOutlined
                  style={{ color: "red" }}
                  onClick={() => {
                    if (record.exp_id === NewRecordKey) {
                      setData(oldData);
                      setCurrentEditingKey("");
                      setNewRecordKey("");
                    } else {
                      setCurrentEditingKey("");
                      setNewRecordKey("");
                    }
                  }}
                />
              </div>
            ) : (
              // When isEditing is false and NewRecordKey is not "tempId"
              <div>
                <EditOutlined
                  style={{ marginRight: "5px", color: "blue" }}
                  onClick={() => {
                    form.setFieldsValue({ ...record });
                    setCurrentEditingKey(record.exp_id);
                  }}
                />
                <Popconfirm
                  title="Are you sure want to delete?"
                  onConfirm={() => handleDeleteCorporate(record)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteOutlined style={{ color: "red" }} />
                </Popconfirm>
              </div>
            )}
          </>
        );
      },
    },
  ];

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    record,
    index,
    children,
    ...restProps
  }) => {
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            // rules={[
            //   {
            //     required: true,
            //     message: `Please Input ${title}!`,
            //   },
            // ]}
          >
            <Input />
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  const GetTableData = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}ExpenseReim/GetCorporateData`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
      .then((response) => {
        setData(response.data.result);
        setLoading(false);
        const newTotalAmount = calculateTotalAmount(response.data.result);
        setTotalAmount(newTotalAmount);
        setCurrentEditingKey("");
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    GetTableData();
  }, []);
 
  const calculateTotalAmount = (data) => {
    const summation = data.reduce((TotalAmount, item) => {
      TotalAmount+=(isNaN(item.amount) || String(item.amount).trim() === ""? parseFloat(0) : parseFloat(item.amount));
      return TotalAmount ;
    }, 0);
    return summation;
  };
  const UploadManualAdjustment = async (options) => {
    // Set a flag to indicate that an upload is in progress
    setAdjUploadFlag(true);

    // Accessing file from upload action
    const { file, onSuccess, onError } = options;

    // Check if the selected file is an Excel file (xls or xlsx)
    if (
      file &&
      file.type !== "application/vnd.ms-excel" &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      message.error("Please upload only .xls or .xlsx files.");
      setAdjUploadFlag(false);
      return;
    }

    //Creating FormData Format to make a HTTP request

    const updatedFile = { file, status: "uploading" };
    const formData = new FormData();
    formData.append("file", file);

    // Read the uploaded Excel file data
    const reader = new FileReader();

    // Wrap the reader.onload callback in an async function
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming the first sheet in the Excel file contains the data with headers in the first row
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to an array of objects (header: value)
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      try {
        // Send the file using axios post request
        setManualLoadingFileName(file.name);
        const url = `${process.env.REACT_APP_BASE_URL}ExpenseReim/CorporateExpUpload`;

        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${jwtToken}`,
          },
        };
        const UploadResponse = await axios.post(url, formData, config);

        // Check the response status and show appropriate message
        if (UploadResponse.data.isSuccess == true) {
          onSuccess(file);
          const fileName = file.name;
          setSelectedFile(file);
          message.success(`${fileName} Uploaded Successfully`);
          updatedFile.status = "done";
          setFileList([updatedFile]);
          GetTableData();
          setUploadSpinLoader(false);
          setManualLoadingFileName("");
        } else {
          onError(file);
          message.error(UploadResponse.data.message);
          updatedFile.status = "error";
          setFileList([updatedFile]);
          setUploadSpinLoader(false);
          setManualLoadingFileName("");
        }

        // Reset the upload loading flag and fetch data into the Grid
        setAdjUploadFlag(false);
        // fetchData();
      } catch (error) {
        // Show an error message and reset the upload flag
        message.error("Please try again");
        setAdjUploadFlag(false);
        // fetchData();
      }
    };

    // Start reading the file as an ArrayBuffer
    reader.readAsArrayBuffer(file);
  };
  const itemRender = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (fileList.length > 0) {
      fileExists = true;
    }
    return (
      <>
        <div
          style={{
            color: statusColor,
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#f2f8fc",
            marginTop: "2px",
            borderRadius: "4px",
          }}
        >
          {fileExists ? fileList[0].file.name : null}
          <DeleteOutlined onClick={() => setFileList([])} />
        </div>
      </>
    );
  };
  const handleDownloadCorporateCSV = () => {
    setSpin(true);
    const columns = [
      {
        title: "Client ID",
        dataIndex: "client_ID",
      },
      {
        title: "Worker ID",
        dataIndex: "worker_ID",
      },
      {
        title: "Org",
        dataIndex: "org",
      },
      {
        title: "Job Number",
        dataIndex: "job_Number",
      },
      {
        title: "Pay Component",
        dataIndex: "pay_Compon",
      },
      {
        title: "Rate",
        dataIndex: "rate",
      },
      {
        title: "Rate Number",
        dataIndex: "rate_Number",
      },
      {
        title: "Hours",
        dataIndex: "hours",
      },
      {
        title: "Units",
        dataIndex: "units",
      },
      {
        title: "Line Date",
        dataIndex: "line_Date",
      },
      {
        title: "Amount",
        dataIndex: "amount",
      },
      {
        title: "Check Seq Number",
        dataIndex: "check_Seq_Number",
      },
      {
        title: "Override State",
        dataIndex: "override_State",
      },
      {
        title: "Override Local",
        dataIndex: "override_Local",
      },
      {
        title: "Override Local Jurisdiction",
        dataIndex: "override_Local_Jurisdiction",
      },
      {
        title: "Labor Override",
        dataIndex: "labor_Override",
      },
      {
        title: "Check Template",
        dataIndex: "check_Template",
      },
      {
        title: "Output Type",
        dataIndex: "output_Type",
      },
      {
        title: "Net Pay",
        dataIndex: "netPay",
      },
      {
        title: "Check Number",
        dataIndex: "checkNumber",
      },
      {
        title: "FIT Amt",
        dataIndex: "fiT_Amt",
      },
      {
        title: "SS Amt",
        dataIndex: "sS_Amt",
      },
      {
        title: "Medicare Amt",
        dataIndex: "medicareAmt",
      },
      {
        title: "Fed Backup Withholding Amt",
        dataIndex: "fedBackup_WithholdingAmt",
      },
      {
        title: "State Tax Jurisdiction",
        dataIndex: "stateTax_Jurisdiction",
      },
      {
        title: "SIT Amount",
        dataIndex: "siT_Amount",
      },
      {
        title: "SDI Amt",
        dataIndex: "sdI_Amt",
      },
      {
        title: "SUI Amt",
        dataIndex: "suI_AmtStateMisc_Amt",
      },
      {
        title: "State Misc Amt",
        dataIndex: "state_Surcharge_Amt",
      },
      {
        title: "State Surcharge Amt",
        dataIndex: "expence_reim_cantingentcol",
      },
      {
        title: "State WC Amt",
        dataIndex: "stateWC_Amt",
      },
      {
        title: "State Backup Withholding Amt",
        dataIndex: "stateBackupWithholding_Amt",
      },
      {
        title: "State Allocation %",
        dataIndex: "state_Allocation",
      },
      {
        title: "Local Tax Jurisdiction",
        dataIndex: "localTax_Jurisdiction",
      },
      {
        title: "Local Tax Name",
        dataIndex: "local_TaxName",
      },
      {
        title: "Local Amt",
        dataIndex: "local_Amt",
      },
      {
        title: "Local Allocation %",
        dataIndex: "local_Allocation",
      },
      {
        title: "File No",
        dataIndex: "file_Name",
      },
      {
        title: "Paychex Code",
        dataIndex: "paychexCode",
      },
      {
        title: "GL Name",
        dataIndex: "gL_Name",
      },
      {
        title: "GL Account #",
        dataIndex: "gL_Account",
      },
      {
        title: "Processed Date",
        dataIndex: "processeddate",
      },
    ];

    const columnHeaders = columns.map((column) => column.title);
    const CSVStructuredData = [columnHeaders];

    for (let i = 0; i < data.length; i++) {
      const rowData = columns.map((column) => data[i][column.dataIndex]);
      CSVStructuredData.push(rowData);
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    for (let i = 0; i < CSVStructuredData.length; i++) {
      worksheet.addRow(CSVStructuredData[i]);
    }

    SuccessMessage("Corporate Expense Csv file downloaded successfully");
    setSpin(false);

    return workbook.csv.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: "text/csv;charset=utf-8" });
      FileSaver.saveAs(blob, "CorporateExpense.csv");
    });
  };
  const handleSavePrepare = () => {
    setDownloadEnabled(true);
  };

  return (
    <>
      <div>
        <div className="contingent-upload-elements">
          {/* <h1 className="expensemain-heading">Corporate Expense</h1> */}
          <div className="contingent-upload">
            <Upload.Dragger
              accept=".xlsx"
              customRequest={UploadManualAdjustment}
              itemRender={itemRender}
              fileList={fileList}
              onRemove={() => setFileList([])}
              className={`contingent-upload-${FileListStatus}`}
            >
              Upload Corporate File
              <UploadOutlined className="upload-iconn" />
              {AdjUploadFlag ? (
                <Spin
                  indicator={
                    <div style={{ alignItems: "center" }}>
                      <LoadingOutlined />
                    </div>
                  }
                ></Spin>
              ) : (
                <></>
              )}
            </Upload.Dragger>
          </div>
      

          <div className="synccsv-div">
            {/* <Button className="sync-button">
              Sync data <ReloadOutlined />
            </Button> */}
            <Button
              className="csv-button"
              onClick={() => handleDownloadCorporateCSV()}
              // disabled={!isDownloadEnabled}
            >
              Download .CSV <DownloadOutlined />
            </Button>
          </div>
        </div>
        <div className="addnew-row">
          <Button className="row-button" onClick={() => AddNewRecord()}>
            Add New Row <PlusOutlined />
          </Button>
          <Input
            placeholder="Search with Worker Id\Client Id\File Number"
            className="input-searchrow"
            style={{ borderColor: "#002766", color: "#F4F9FF" }}
            onChange={(e) => SearchEmployee(e.target.value)}
            suffix={
              <SearchOutlined
                style={{ color: "#002766", justifyContent: "space-between" }}
              />
            }
          />
        </div>
        <div className="contingent-table">
          <Form form={form} component={false}>
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              columns={mergedColumns}
              dataSource={data}
              pagination={false}
              scroll={{ x: "max-content", y: 300 }}
              loading={loading}
              bordered
            />
          </Form>
          <div style={{ right: "0", position: "absolute" }}>
            <Button className="total-amount">
              Total Amount: ${totalAmount.toFixed(2)}
            </Button>
            {/* <Button
              className="prepare-button"
              onClick={handleSavePrepare}
              disabled={isDownloadEnabled}
            >
              Prepare
            </Button> */}
          </div>
        </div>
      </div>
    </>
  );
};
export default CorporateExpense;
